<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Display Schedule</h1>
        </div>
    </div>

    <!-- Develop this div appropriately -->
    <div class="container">
        <form>
            <label for="start"><br><b>Enter Start Stop</b> </label><br>
            <input [(ngModel)]='selectedBusFrom' (ngModelChange)='changeFrom()' type="text" id="start" name="start" required
                autocomplete="off"><br>
            <label for="destination"><br><b>Enter Destination Stop</b> </label><br>
            <input [(ngModel)]='selectedBusTo' (ngModelChange)='changeTo()' type="text" id="destination" name="destination" required
                autocomplete="off"><br>
            <div class='suggestionsOuterContainer'>
                <div id='spacer'></div>
                <div class="listSuggestions">
                    <div *ngIf='enteredTextFrom'>
                        <div class='listItems' *ngFor="let stop of stopNames | appFilter: selectedBusFrom">
                            <button (click)='sendToFieldFrom(stop)'>{{stop}}</button>
                        </div>
                    </div>
                    <div *ngIf='enteredTextTo'>
                        <div class='listItems' *ngFor="let stop of stopNames | appFilter: selectedBusTo">
                            <button (click)='sendToFieldTo(stop)'>{{stop}}</button>
                        </div>
                    </div>
                </div>
                <div id='spacer'></div>
            </div>

            <input type="submit" value="View Schedule" (click)="submit()">
        </form>

    </div>
</div>